export const classes = {
  logoRow: 'flex justify-center',
  middle: 'flex flex-1 flex-col items-center justify-center gap-2',
  avatarWrap:
    'mb-[46px] size-[118px] overflow-hidden rounded-full bg-[linear-gradient(150deg,#9fb8cc,#7fa2ba)] shadow-[0_16px_34px_-12px_rgba(60,80,110,0.5)]',
  avatar: 'size-full',
  welcome:
    'text-[24px] font-extrabold tracking-[-0.01em] text-taupe-3 dark:text-mauve-1',
  message: 'text-[14.5px] text-taupe-2 dark:text-mauve-2',
  logoutRow: 'flex justify-center',
};
